import { Box, BoxProps, SizableText, VisibilityBadge, XStack } from '@my/ui'
import { GroupCardInfo, GroupCardInfoProps } from './group-card-info'
import { GroupCardControls, GroupCardControlsProps } from './group-card-controls'
import millify from 'millify'
import { GroupCardInfoExtra } from './group-card-info-extra'

export type GroupCardHorizontalProps = GroupCardInfoProps & GroupCardControlsProps

/**
 * Regular horizontal card for displaying group information.
 */
export const GroupCardHorizontal = ({
  id,
  name,
  visibility,
  totalMembers,
  href,
  profileImage,
  hasPendingRequest,
  hasJoined,
  canJoin,
  isAdmin,
  canLeave,
  ...props
}: GroupCardHorizontalProps & BoxProps) => {
  return (
    <Box flexDirection="column" flex={1} gap="$4" ai="stretch" {...props} shadowRadius={6}>
      <GroupCardInfo
        flex={1}
        name={name}
        href={href}
        visibility={visibility}
        totalMembers={totalMembers}
        profileImage={profileImage}
      />

      <XStack alignItems="center" justifyContent="space-between">
        <GroupCardInfoExtra visibility={visibility} totalMembers={totalMembers} />
        <GroupCardControls
          h="auto"
          id={id}
          href={href}
          ai="flex-end"
          jc="space-between"
          canJoin={canJoin}
          hasJoined={hasJoined}
          visibility={visibility}
          hasPendingRequest={hasPendingRequest}
          canLeave={canLeave}
          isAdmin={isAdmin}
        />
      </XStack>
    </Box>
  )
}
